import styled from 'styled-components'
import Footer from '../components/general/Footer'
import Nav from '../components/general/Nav'
import OfflineIndicator from '../components/general/OfflineIndicator'

interface ILayoutProps {
	children: React.ReactNode
}

const LayoutWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	overflow: hidden;
`

const Layout: React.FunctionComponent<ILayoutProps> = ({ children }) => {
	return (
		<LayoutWrapper>
			<OfflineIndicator />
			<Nav />
			{children}
			<Footer />
		</LayoutWrapper>
	)
}

export default Layout
